import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import * as Alert from '../../../../../components/Alert/Alert';
import { useAppDispatch } from '../../../../../reduxService/hooks';
import { endpoint } from '../../../../pages';
import { cleanProjectInfo } from '../../../../store/projectInfo/projectInfoSlice';
import { INewButtonProps } from './INewButton';
import './NewButton.scss';

const NewButton = (props: INewButtonProps) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const handleClick = () => {
        Alert.confirm({
            title: t('project_info_title'),
            message: t('header_new_button_alert_body'),
            confirmText: t('header_new_button'),
            cancelText: t('cancel_button'),
            onConfirm: () => {
                dispatch(cleanProjectInfo());
                navigate(endpoint.projectInfo);
            },
            onCancel: () => {
                // Optional: handle cancel action here if needed.
            },
        });
    };

    return (
        <button type='button' className={props.className} onClick={handleClick}>
            <i className='fa-solid fa-plus-circle' />
            {t('header_new_button')}
        </button>
    );
};

export default NewButton;
